module.exports = __webpack_public_path__ + "img/code6.e7e67661.png";